export default "__VITE_ASSET__BrwEKMtM__"